module.exports = __webpack_public_path__ + "img/ph_article.a68fb485.svg";